/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Win2_TInputs */

const en_wc_vs_win2_t = /** @type {(inputs: Wc_Vs_Win2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open source you can audit`)
};

/**
* | output |
* | --- |
* | "Open source you can audit" |
*
* @param {Wc_Vs_Win2_TInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_win2_t = /** @type {((inputs?: Wc_Vs_Win2_TInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Win2_TInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_win2_t(inputs)
});
export { wc_vs_win2_t as "wc.vs.win2.t" }